import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewEncapsulation, ViewChild } from '@angular/core';

@Component({
  selector: 'popover',
  template: `
 
    <div *ngIf="screenwidth === 'LG' || screenwidth === 'XL'" style="margin-top: 10px;">
      <div class="tooltip" [ngClass]="{'tooltip-active': expanded}" style="margin-left: 10px; margin-top: -12px;">
        <span class="login-prompt" [ngClass]="type === 'e_s'? 'bundle-width' : 'availability-width'">
          <span *ngIf="bundle" class="text" style="line-height: 18px;">
            {{bundle}}
          </span>
          <span *ngIf="availability" class="text" style="line-height: 18px;">
            {{availability}}
          </span>
        </span>
        <div class="tooltip-pointer" style="margin-left: 0px;"></div>
      </div>
      <div (mouseover)="expanded=true;" (mouseleave)="expanded=false;">
        <span [ngClass]="type === 'e_s'? 'info-icon' : 'bundle-icon'">{{type | translate}}</span>
      </div>
    </div>

    <div *ngIf="screenwidth === 'SM' || screenwidth === 'MD'" style="margin-top: 10px;">
      <div class="tooltip" [ngClass]="{'tooltip-active': expanded}" style="margin-left: 10px; margin-top: -12px;">
        <span class="login-prompt" [ngClass]="type === 'Adobe Offer'  || type === 'a_o' || type === 'e_s'? 'bundle-width' : 'availability-width'">
          <span *ngIf="bundle" class="text" style="line-height: 18px;">
            {{bundle}}
          </span>
          <span *ngIf="availability" class="text" style="line-height: 18px;">
            {{availability}}
          </span>
        </span>
        <div class="tooltip-pointer" style="margin-left: 0px;"></div>
      </div>
      <div (click)="toggle()">
        <span [ngClass]="type === 'e_s'? 'info-icon' : 'bundle-icon'">{{type | translate}}</span>
      </div>
    </div>
   
  `
})
export class PopoverComponent implements OnInit {
  @Input() screenwidth: string;
  @Input() type: string;
  @Input() bundle?: string;
  @Input() availability?: string;
  @Input() data?: string;

  // @Output() viewType = new EventEmitter<Event>();
  private expanded;

  constructor(
  ) {
  }

  ngOnInit() {
    this.expanded = false;

  }
  checkOfferType(bundle, offerType) {
    try {
      return (bundle.indexOf(offerType) != -1)
    } catch (err) {
      console.error(bundle);
      return false;
    }
  }
  getOfferTypeText(bundle, offerType) {
    var offerArray = bundle.split("=#=");
    var offerVal = "";
    for (var oi = 0; oi < offerArray.length; oi++) {
      var offerTypeValue = offerArray[oi].split("=");

      if (offerTypeValue.length > 0 && offerTypeValue[0] === offerType) {
        offerVal = offerTypeValue[1];
      }
    }
    return offerVal;
  }
  toggle() {
    if (jQuery("popover .tooltip").hasClass("tooltip-active")) {
      jQuery("popover .tooltip").removeClass("tooltip-active");
    }
    this.expanded = !this.expanded;
  }

}
